function addMembershipsPurchaseBulkInvitationsEmailsFields() {
    const checkedFields = $('.js-dt-checkbox:checked');
    const container = $('.js-memberships-bulk-invitation-fields-wrapper');
    container.empty();

    checkedFields.each(function (index) {
        const markup = `<div
                        class="df fdc gap-8 js-memberships-bulk-invitation-field-parent"
                    >
                        <label for="memberships-bulk-invitation-field-${index}" class="fz-15-26 c-gray-5">Email address</label>
                        <div class="form-item-wrap h-48 pos-relative">
                            <input
                                id="memberships-bulk-invitation-field-${index}"
                                name="memberships-bulk-invitation-field-${index}"
                                class="form-item form-item--btn js-field-with-btn js-memberships-bulk-invitation-field"
                                type="text"
                                placeholder=""
                            />
                            <button class="btn-field-clear js-btn-field-clear" type="button"></button>
                        </div>
                        <div
                            class="fz-12-16 fw-600 c-orange hidden-block js-field-sign js-memberships-invitation-sign"
                        >
                            You entered incorrect email
                        </div>
                    </div>`;

        container.append(markup);
    });
}

$(document).on('click', '.js-open-bulk-invitation-popup-btn', function () {
    addMembershipsPurchaseBulkInvitationsEmailsFields();
    setTimeout(() => {
        // Remove previous event listeners before adding new ones
        const form = $('.js-memberships-bulk-invitation-form');
        form.off('submit'); // Remove all previous submit handlers
        validateMembershipsBulkInvitation();
    }, 0);
});
